import { render, staticRenderFns } from "./AutomationsOverview.vue?vue&type=template&id=509f531c&"
import script from "./AutomationsOverview.vue?vue&type=script&lang=js&"
export * from "./AutomationsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports